import React, { useMemo } from "react";

import PropTypes from "prop-types";
import Danger from "shared/components/SVG/Danger";
import Warning from "shared/components/SVG/Warning";
import "./styles.scss";

const LEVELS_ICON = {
  error: Danger,
  warning: Warning,
};

const Component = ({ level, message, visible }) => {
  const Icon = useMemo(() => LEVELS_ICON[level], [level]);

  return (
    <>
      {visible && (
        <div className={`message-container message-container-${level}`}>
          <div>
            <Icon />
          </div>
          <p>{message}</p>
        </div>
      )}
    </>
  );
};

Component.propTypes = {
  visible: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  level: PropTypes.oneOf(Object.keys(LEVELS_ICON)).isRequired,
};

Component.defaultProps = {};

export default Component;
